import Hidden from '@material-ui/core/Hidden';
import React, { useState, useEffect } from "react";
import { withRouter } from 'react-router-dom';
import useStyles from './styles';

const Sidebar = (props) => {

  const classes = useStyles();
  const { history } = props;
  const [itemAtivo, setItemAtivo] = useState(2);

  useEffect(() => {
    const { pathname } = history.location;
    
    if (pathname.includes('reuniao') || pathname.includes('reunioes')) {
      setItemAtivo(0)
    }

    if (pathname.includes('biblioteca')) {
      setItemAtivo(1)
    }

    if (pathname.includes('quem-e-quem') || pathname.includes('usuario')) {
      setItemAtivo(2)
    }

    if (pathname.includes('formulario') || pathname.includes('formularios')) {
      setItemAtivo(3)
    }
  }, [history?.location])


  const redirecionar = (url) => {
    history.push(url)
  }

  return (
    <>
      <Hidden smDown>
        <div className={classes.sideBar}>
          <ul style={{ padding: 0, paddingTop: 30, margin: 0 }}>
            <li onClick={() => redirecionar('/reunioes', 0)} className={itemAtivo === 0 ? classes.itensSelecionado : classes.itens}>Reuniões</li>
            <li onClick={() => redirecionar('/biblioteca', 1)} className={itemAtivo === 1 ? classes.itensSelecionado : classes.itens}>Biblioteca</li>
            <li onClick={() => redirecionar('/quem-e-quem', 2)} className={itemAtivo === 2 ? classes.itensSelecionado : classes.itens}>Quem é Quem</li>
            <li onClick={() => redirecionar('/formularios', 3)} className={itemAtivo === 3 ? classes.itensSelecionado : classes.itens}>Formulários</li>
          </ul>
        </div>
      </Hidden>
    </>
  );
}

export default withRouter(Sidebar); 
